"use client";

import { ForwardedRef, forwardRef } from "react";

export interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {}

const Form = forwardRef(
  (
    { children, className, ...rest }: FormProps,
    ref: ForwardedRef<HTMLFormElement>,
  ) => (
    <form ref={ref as any} className={className || "unchained-form"} {...rest}>
      {children}
    </form>
  ),
);

Form.displayName = "Form";

export default Form;
